'use client';

import { CloseButton as HeadlessCloseButton } from '@headlessui/react';
import classNames from '@/utils/classNames';
import { Button } from '@/components/Button';

import type { Ref } from 'react';
import type { ModalCancelButtonProps } from './Modal.types';

const baseClassName = ['w-24', 'font-normal'];

const CancelButton = ({
  className,
  children = 'Cancel',
  ref,
  ...props
}: ModalCancelButtonProps & { ref?: Ref<HTMLButtonElement> }) => (
  <Button
    className={classNames(baseClassName, className)}
    type="reset"
    size="xs"
    ref={ref}
    as={HeadlessCloseButton}
    {...props}
  >
    {children}
  </Button>
);

export default CancelButton;
